import { FC } from 'react';
import { ActionLogEntityType } from '@mews-commander/types';
import { BillLink } from '../../../components/commander-ui';
import OrderItemLink from '../../billing/components/OrderItemLink';

interface ActionLogItemLinkProps {
    entityType: ActionLogEntityType;
    entityId: string;
}

const ActionLogItemLink: FC<ActionLogItemLinkProps> = ({ entityId, entityType }) => {
    if (entityType === ActionLogEntityType.Bill) {
        return <BillLink billId={entityId} />;
    }
    if (entityType === ActionLogEntityType.OrderItem) {
        return <OrderItemLink orderItemId={entityId} />;
    }
    return null;
};

export default ActionLogItemLink;
